import type { ComponentProps } from 'react';

const Profile = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.875 7C14.875 6.1712 14.5458 5.37634 13.9597 4.79029C13.3737 4.20424 12.5788 3.875 11.75 3.875C10.9212 3.875 10.1263 4.20424 9.54029 4.79029C8.95424 5.37634 8.625 6.1712 8.625 7C8.625 7.8288 8.95424 8.62366 9.54029 9.20971C10.1263 9.79576 10.9212 10.125 11.75 10.125C12.5788 10.125 13.3737 9.79576 13.9597 9.20971C14.5458 8.62366 14.875 7.8288 14.875 7ZM6.75 7C6.75 5.67392 7.27678 4.40215 8.21447 3.46447C9.15215 2.52678 10.4239 2 11.75 2C13.0761 2 14.3479 2.52678 15.2855 3.46447C16.2232 4.40215 16.75 5.67392 16.75 7C16.75 8.32608 16.2232 9.59785 15.2855 10.5355C14.3479 11.4732 13.0761 12 11.75 12C10.4239 12 9.15215 11.4732 8.21447 10.5355C7.27678 9.59785 6.75 8.32608 6.75 7ZM4.92578 20.125H18.5781C18.2305 17.6523 16.1055 15.75 13.5391 15.75H9.96875C7.40234 15.75 5.27734 17.6523 4.92969 20.125H4.92578ZM3 20.8398C3 16.9922 6.11719 13.875 9.96484 13.875H13.5352C17.3828 13.875 20.5 16.9922 20.5 20.8398C20.5 21.4805 19.9805 22 19.3398 22H4.16016C3.51953 22 3 21.4805 3 20.8398Z"
        fill="#55657D"
      />
    </svg>
  );
};

export default Profile;
